import React from 'react';

const Title = ({children}) => {
    return (
        <div className='text-center'>
            <h2 className='text-4xl text-[#0b163f] font-bold'>{children}</h2>
        </div>
    );
};

export default Title;